import React from "react";
import "./Checkbox.css";

const Checkbox = ({ id, label, checked, onChange }) => {
  return (
    <label className="checkbox-container" htmlFor={id}>
      <input type="checkbox" id={id} checked={checked} onChange={onChange} />
      <span className="checkmark"></span>
      {label}
    </label>
  );
};

export default Checkbox;
